import {useState} from 'react';
import {keepPreviousData, useQuery} from '@tanstack/react-query';
import {amount, client, result} from './api';

export function NormResources({normId}: {normId: string}) {
  const [open, setOpen] = useState(false);
  const [version, setVersion] = useState('');
  const lookup = useQuery({queryKey: ['norm-resources', normId, version], enabled: open,
    placeholderData: keepPreviousData,
    queryFn: () => result(client.GET('/api/v1/norms/{norm_id}/resources', {
      params: {path: {norm_id: normId}, query: version ? {version_id: version} : {}},
    }))});
  const data = lookup.data, selected = data?.selected, payload = selected?.payload;
  return <details className="norm-resources" onToggle={e => setOpen(e.currentTarget.open)}>
    <summary>Ресурсы нормы и исходник</summary>
    {lookup.isFetching && <p className="muted">Читаем сохранённую карточку…</p>}
    {lookup.error && <p role="alert">Не удалось открыть ресурсы нормы. <button type="button" onClick={() => void lookup.refetch()}>Повторить</button></p>}
    {data && !selected && <p className="muted">Ресурсная часть ещё не загружена. Наличие нормы не подтверждает расход и стоимость материалов.</p>}
    {data && data.versions.length > 1 && <label className="field"><span>Версия исходника ресурсов</span>
        <select value={version} onChange={e => setVersion(e.target.value)}>
          <option value="">Текущая версия</option>
          {data.versions.filter(v => v.id !== data.current_version_id).map(v =>
            <option value={v.id} key={v.id}>{v.filename} · {new Date(v.created_at).toLocaleString('ru-RU')}</option>)}
        </select>
    </label>}
    {data && selected && payload && !lookup.isPlaceholderData && <>
      {selected.id !== data.current_version_id && <p className="notice">Историческая версия. Значения сохранены из прежнего исходника.</p>}
      <p><strong>Расход на {payload.norm_unit} нормы</strong><br/>
        <span className="muted">Это не объём ВОР. Для расчёта стоимости нужно проверить единицы и учтённость ресурсов.</span></p>
      {!payload.resources.length && <p className="notice">В этом исходнике расход ресурсов не раскрыт. Это не означает нулевой расход.</p>}
      <ul className="norm-resource-list">{payload.resources.map((r, i) => <li key={i}>
        <span><strong>{r.name || r.code || 'Ресурс без наименования'}</strong><small>{r.code}</small></span>
        <span>{r.quantity == null ? <><b>Расход не установлен</b>{r.quantity_text && <small>В исходнике: «{r.quantity_text}»</small>}</> : <b>{amount(r.quantity)}</b>}
          <small>{r.unit || 'Единица не указана'}</small></span>
      </li>)}</ul>
      {!!payload.references.length && <details><summary>Ссылки на НР/СП в исходнике</summary>
        <p className="muted">По этим ссылкам позиция получает НР и СП автоматически, если для неё не задана своя ставка.</p>
        {payload.references.map((r, i) => <p key={i}>{Object.entries(r).map(([k,v]) => `${k}: ${v}`).join(' · ')}</p>)}
      </details>}
      {!!payload.operations.length && selected.id !== data.current_version_id && <details>
        <summary>Состав работ в этой версии XML</summary><ul>{payload.operations.map((text,i) => <li key={i}>{text}</li>)}</ul>
      </details>}
      <p className="muted">{selected.filename} · {payload.member}<br/>
        {payload.norm_code} · уровень цен исходника: {payload.base.PriceLevel || 'не указан'}</p>
      <a className="source-link" href={selected.download_url} download>Скачать точный исходник ресурсов</a>
    </>}
  </details>;
}
